import { useLocation } from "react-router-dom";

import { useConnections } from "src/api/connectApi/queries";
import { useWorkspaceContext } from "src/router/routerContextHooks";
import { DashboardPageParams, getUrlToRetoolPage } from "src/router/urls";
import { useParamsDecode } from "src/utils/useParamsDecode";

export const useRetoolInformation = () => {
  const { wsId, orgId } = useParamsDecode<DashboardPageParams>();
  const { workspace } = useWorkspaceContext();

  const connections = useConnections(workspace.base_url);
  const retoolConnection = connections.data?.find(
    (c) => c.provider === "retool",
  );
  const location = useLocation();

  const retoolPageUrl = getUrlToRetoolPage(orgId, wsId, retoolConnection?.id);
  const isCurrentPageRetool =
    `${location.pathname}${location.search}` === `${retoolPageUrl}`;
  return { retoolPageUrl, retoolConnection, isCurrentPageRetool };
};
